<template>
	<div class="submitDetails">
		<div class="listBox">
			<ul>
				<li><span>工单号：</span><span>{{gdData.wt.id}}</span></li>
				<li><span>提单人：</span><span>{{gdName}}</span></li>
				<li><span>联系电话：</span><span>{{gdData.wt.mobileno}}</span></li>
				<li><span>当前状态：</span><span>{{status[gdData.wt.status - 1]}}</span></li>
			</ul>
			<el-button v-if="gdData.wt.status < 3" class='btn' type="primary" @click='deleteFun(gdData.wt.id)'>结单</el-button>
		</div>
		<h3>沟通记录</h3>
		<div class="speakBox">
			<ul>
				<li v-for="item in gdData.list">
					
					
					<template v-if="item.creatorType == 1" >
						<p class="name">用户:{{gdName}}</p>
						<p class="wenti"><span>问</span>{{item.replyText}}</p>	
					</template>
					<template v-else>
						<p class="name">客服:admin</p>
						<p class="wenti"><span class="green">答</span>{{item.replyText}}</p>	
					</template>
					<p class="time">{{setTime(item.createAt)}}</p>
					<div class="fileBox">
						<ul>
							<li v-for="item1 in item.listArr">
								<img v-if="item1.status == 1" :src="item1.url" alt="" @click="centerDialogVisible3 =true;fileArrurl=item.listArr">
								<a v-else :href="item1.url" download="下载" class="el-icon-download" :title="item1.url" target="_blank">下载</a>
							</li>
						</ul>
					</div>
				</li>
			</ul>
			<template v-if="gdData.wt.status < 3">
				<div class="huifu">
					<el-input type="textarea" v-model="replyText" placeholder="请输入内容"></el-input>
				</div>
				<div class="uploadBox">
					<el-upload class="upload-demo" 
					ref="upload" 
					action="aaa" 
					:on-preview="handlePreview" 
					:on-remove="handleRemove" 
					:before-remove="beforeRemove"
					 multiple 
					 :limit="5" 
					 :on-exceed="handleExceed" 
					 :file-list="fileList" 
					 :before-upload="beforeAvatarUpload"
					 :http-request="requestFile"
					 >
						<el-button size="small" type="primary" :loading="uploadBtn">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">可支持.png、.jpg、.jpeg、.txt、.rar、.doc、.xlsx、.zip、.7z格式，最大不超过5M</div>
					</el-upload>
				</div>				
			</template>

		</div>
		<el-button v-if="gdData.wt.status < 3" class='btn1' type="primary" @click='creatFun'>添加回复</el-button>
		<el-dialog title="附件查看" :visible.sync="centerDialogVisible3" center>
			<el-carousel :interval="4000" type="card" height="200px">
				<el-carousel-item v-for="(item,index) in fileArrurl" :key="index" v-if="item.status == 1">
				  <img class="img" style="width: 100%;" :src="item.url" v-if="item.status == 1">
				</el-carousel-item>
			</el-carousel>
		</el-dialog>		
	</div>
</template>

<script>
	import axios from 'axios'
	import { replyGd,createGdClose } from '@/axios/api.js'
	import common from '@/assets/common.js'
	export default {
		data() {
			return {
				uploadBtn: false,
				status:['已提交','已处理待反馈','已关闭-用户','已关闭-系统'],
				gdData:{},
				gdName:JSON.parse(window.localStorage.getItem("token")).data.obj.name,
				fileUrl: [],
				fileList: [],
				replyText:'',
				centerDialogVisible3:false,
				fileArrurl:[],
				saveReplyText:'',
			};
		},
		created() {
			this.gdData=this.$route.params.data;
			if(this.gdData == undefined) return this.$router.go(-1)
			var reg = /(.*)\.(jpg|gif|bmp|png)$/;
			this.gdData.list.forEach(item => {	
				if(item.attachments == '[]' || item.attachments == undefined) return
				if(typeof(item.attachments) == 'string'){
					item.attachments=JSON.parse(item.attachments);
				}
				var listArr=[];
				item.attachments.forEach((item,index) => {
					if(reg.test(item)){
						listArr.push({url:item,status:1})
					}else{
						listArr.push({url:item,status:0})
					}
				})
				item.listArr=listArr
			})
			console.log(this.gdData)
		},
		methods: {
			setTime(time){
				return common.time(time)
			},			
			//上传
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			beforeAvatarUpload(file) {
				const isLt8M = file.size / 1024 / 1024 < 8;
				const reg = /(.*)\.(png|jpg|jpeg|txt|rar|doc|xlsx|zip|7z)$/
				if (!isLt8M) {
					this.$message.error('上传头像图片大小不能超过 8MB!');
				}
				const isxlsx = reg.test(file.name)
				if (!isxlsx) {
					this.$message.error("上传只支持.png、.jpg、.jpeg、.txt、.rar、.doc、.xlsx、.zip、.7z格式");
				}
				return isLt8M && isxlsx;
			},
			requestFile(param) {
				this.uploadBtn = true;
				var fileObj = param.file
				let config = {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				};
				var form = new FormData() // FormData 对象
				var token = JSON.parse(window.localStorage.getItem("token")).data.obj.token
				form.append('file', fileObj) // 文件对象
				form.append('token', token) // 文件对象
				axios.post(API_BASE + 'rescue_sale/sale/upload', form, config)
					.then(res => {
						if (res.data.code == 0) {
							this.fileUrl.push(res.data.obj);
							this.uploadBtn = false
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			creatFun() {
				if(this.replyText == '') return this.$message.warning('回复不能为空！')
				var data = {
					ticketId:this.gdData.wt.id,
					replyText:this.replyText,
					attachments:JSON.stringify(this.fileUrl)
				}
				replyGd(data)
					.then(res => {
						console.log(res);
						var reg = /(.*)\.(jpg|gif|bmp|png)$/;
						var listArr=[];
						if (res.data.code == 0) {
							this.$message({
								message: '恭喜您，提交成功！',
								type: 'success'
							});
							this.fileUrl.forEach((item,index) => {
								if(reg.test(item)){
									listArr.push({url:item,status:1})
								}else{
									listArr.push({url:item,status:0})
								}
							})						
							this.saveReplyText=this.replyText;
							this.gdData.list.push({replyText:this.saveReplyText,listArr:listArr,creatorType:1})
							this.replyText='';
							this.$refs.upload.clearFiles();
							this.fileUrl=[]
						}
					})
					.catch(err => {
						console.log(err)
					})
			},
			deleteFun(id){
				var data={
					id
				}
				createGdClose(data)
				.then(res => {
					console.log(res)
					if(res.data.code == 0){
						this.$message({
						  message: '工单已关闭！',
						  type: 'success'
						});
						this.gdData.wt.status=3;
					}else{
						this.$message.error(res.data.msg)
					}
				})
				.catch(err => {
					console.log(err)
				})
			}			
		}
	}
</script>

<style scoped="scoped">
	.listBox {
		overflow: hidden;
	}

	.listBox ul {
		overflow: hidden;
		width: 800px;
		float: left;
	}

	.listBox ul li {
		float: left;
		width: 300px;
		line-height: 30px;
		color: #666;
	}

	.listBox .btn {
		float: left;
		margin-top: 20px;
	}

	h3 {
		font-size: 18px;
		font-weight: normal;
		margin: 20px 0;
	}

	.name {
		color: #666;
		font-size: 14px;
	}

	.wenti {
		margin-top: 10px;
		font-size: 14px;
	}

	.wenti span {
		font-size: 20px;
		padding-right: 13px;
		color: #00ABFA;
	}

	.wenti span.green {
		color: #13CE66;
	}

	.time {
		text-align: right;
		font-size: 14px;
		color: #666;
	}

	.huifu {
		margin-top: 20px;
	}

	.uploadBox {
		margin-top: 20px;
		width: 450px;
	}
	.speakBox{max-width: 800px;}
	
	.btn1{display: block;margin: 0 auto;margin-top: 20px;}
	.fileBox ul{overflow: hidden;}
	.fileBox ul li{float: left;}
	.fileBox ul li img{height: 100px;margin-right: 10px;cursor: pointer;}
	.fileBox ul li a{line-height: 100px;padding: 0 10px;}
	.img{height: 100%;}
	.submitDetails{height: calc(100vh - 120px);overflow-y: auto;padding-bottom: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/shop/submitDetails.vue